import { render, staticRenderFns } from "./baseprice.vue?vue&type=template&id=d177f64e&scoped=true"
import script from "./baseprice.vue?vue&type=script&lang=js"
export * from "./baseprice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d177f64e",
  null
  
)

export default component.exports